export const USER_AVATAR_SIZE = 80;
export const USER_AVATAR_SIZE_MOBILE = 46;

export const OBSERVER_THRESHOLD_IN = 0;
export const OBSERVER_THRESHOLD_OUT = 0.1;
